<template>
    <div class="cg-head" >
       	<span @click="goBack()" class="logo">
       		<img :src="isGlobal ? 'static/images/logo.png' : 'static/images/logo_cn.png'" alt="logo" />
       	</span>

        <span  class="selcountry" v-if="isGlobal" @click="modalStatus = !modalStatus">
        	<!-- <img v-if="conutry.src" :src="'static/images/country/'+conutry.src+'.png'" alt="country" />
          <template v-else>
            <span>{{ $t(`country.${conutry.content}`)}}</span>
            <span style="margin: 0 4px;">|</span>
          </template> -->
          {{ localeMap[$i18n.locale] }}
        </span>
        <transition name="pop-up" >
          <ToggleModal
            v-if="modalStatus"
            :currentLocale="$i18n.locale"
            :currentConutry="conutry"
            @selectConutry="toggleConutry"
            @selectLang="toggleLang"
            @close="modalStatus = false"
          />
        </transition>
    </div>
</template>

<script>
  import { mapGetters,mutations } from 'vuex';
  import conutryarr from '../country.js'
  import {localeMap} from '../../../tool/constant';
  import ToggleModal from './toggleModal.vue';

  export default {

    data() {
      return {
        modalStatus: false,
        localeMap,
      }
    },
    computed: {
      ...mapGetters([
        'conutry',
        'isGlobal',
        'accept'
      ]),
    },
    watch: {
      modalStatus(val) {
        document.documentElement.style.overflow = val ? 'hidden' : ''
      }
    },
    components: {
      ToggleModal
    },
    created(){
      this.initLang()
      this.$ta.setSuperProperties({
        lang: this.$i18n.locale
      })
    },
    mounted() {

    },
    methods:{
      goBack(){
        // window.scrollTo(0,0);
        // if(this.$route.path!='/'){
        //   this.$router.push({path:'/'});
        // }
      },
      toggleConutry(item){
        this.$store.commit('SET_COUNTRY',item);
      },
      toggleLang(locale) {
        this.$i18n.locale = locale

        this.$ta.setSuperProperties({
          lang: locale
        })
        window.localStorage.setItem('vipMallLangCode', locale);
      },
      initLang() {
        const lang = window.localStorage.getItem('vipMallLangCode');
        this.$i18n.locale = lang || this.getBrowserLang()
      },
      getBrowserLang() {
        const lang = (navigator.appName=='Netscape' ? navigator.language : navigator.userLanguage).toLowerCase()
        if (lang === 'zh' || lang === 'zh-cn' || lang.startsWith('zh-Hans')) {
          return 'zh-Hans' // 简体中文
        } else if (lang.startsWith('en')) {
          return 'EN' // 英文
        } else if (lang.indexOf('zh-tw') > -1 || lang.indexOf('zh-hant') > -1 || lang.indexOf('zh-mo') > -1 || lang.indexOf('zh-hk') > -1) {
          return 'zh-Hant' // 繁中
        } else if (lang.startsWith('de')) {
          return 'DE' // 德语
        } else if (lang.startsWith('fr')) {
          return 'FR' // 法语
        } else if (lang.startsWith('es')) {
          return 'ES' // 西班牙语
        } else if (lang.startsWith('id')) {
          return 'ID' // 印尼语
        } else if (lang.startsWith('th')) {
          return 'TH' // 泰语
        } else if (lang.startsWith('ru')) {
          return 'RU' // 俄语
        } else if (lang.startsWith('vi')) {
          return 'VI' // 越南语
        } else if (lang.startsWith('ko')) {
          return 'KO' // 韩语
        } else if (lang.startsWith('ja')) {
          return 'JA' // 日语
        } else if (lang.startsWith('ar')) {
          return 'AR' // 阿拉伯语
        } else if (lang.startsWith('pt')) {
          return 'PT' // 葡萄牙语
        } else if (lang.startsWith('tr')) {
          return 'TR' // 土耳其语
        } else if (lang.startsWith('it')) {
          return 'IT' // 意大利语
        } else if (lang.startsWith('nl')) {
          return 'NL' // 兰语语
        } else if (lang.startsWith('pl')) {
          return 'PL' // 波兰语
        } else {
          return 'EN'
        }
      }
    },

  }
</script>

<style scoped>
  .cg-head{
  	width: 100%;
  	position: fixed;
  	background-color: #FFFFFF;
  	top: 0;
  	left: 0;
    height: 3.125rem;
    z-index: 100;
    box-shadow: 0px 0px 1rem 0px rgba(32, 41, 55, 0.63);
  }
  .cg-head header{
  	width: 100%;
  	margin: 0 auto;
  }
  .logo img{
  	height: 1.875rem;
  	width: auto;
    margin-left: 0.625rem;
    margin-top: 0.625rem;
  	float: left;
    cursor: pointer;
  }
  .selcountry{
    position: absolute;
    right: 12px;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #404d5e;
    cursor: pointer;
    white-space: nowrap;
  }
  .selcountry img{
    height: 24px;
    border: .5px solid #ccc;
    margin-right: 5px;
  }

  @media (max-width: 1024px) {
    .pop-up-enter-active, .pop-up-leave-active {
      transition: all 200ms;
    }
    .pop-up-enter, .pop-up-leave-to, .pop-up-leave-active {
      opacity: 0;
      transform: translate(0, 10%);
    }
  }
  @media (min-width: 1024px) {
    .pop-up-enter-active, .pop-up-leave-active {
      transition: all 200ms;
    }
    .pop-up-enter, .pop-up-leave-to, .pop-up-leave-active {
      opacity: 0;
    }
  }



</style>



// WEBPACK FOOTER //
// src/components/common/head/index.vue